// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__Td2rp","avatar":"Profile_avatar__QukLO","box":"Profile_box__1MKW9","card":"Profile_card__hNrB1","dlImage":"Profile_dlImage__bMtq6"};